// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"lp-z","outfitFeedbackSection":"mp-z"};